/* eslint-disable no-undef */
class GrapheneHCMultiBuyCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const carouselOptions = this.closest(
      '[data-graphenehc-carousel-desktop-slide-count]'
    )
    this.carousel = this.setupCarousel(carouselOptions)
  }

  setupListeners () {
    // Watch for checkbox changes
    document
      .querySelectorAll('[data-graphenehc-multibuy-carousel-el="itemCheckbox"]')
      .forEach(checkbox => {
        checkbox.addEventListener('change', e => {
          if (
            checkbox.hasAttribute(
              'data-graphenehc-carousel-product-has-variants'
            )
          ) {
            this.handleProductWithVariants(e)
          } else {
            this.handleProductCheckboxChange(e)
          }
        })
      })

    // Run on load to calculate the initial total
    this.handleProductCheckboxChange()

    // Attach click listeners to variants directly within this carousel
    this.querySelectorAll('.prd-Card_Variant').forEach(variant => {
      variant.addEventListener('click', e =>
        this.handleProductWithVariantsClick(e)
      )
    })
  }

  handleProductCheckboxChange () {
    this.updateTotalPrice()
    this.updateTotalItems()
    this.updateItemsArray()
  }

  handleProductWithVariants (e) {
    const parentItem = e.target.closest('.js-ProductCards_Card')

    if (e.target.checked) {
      parentItem.classList.add('prd-Cards_CardWithVariants-active')
    } else {
      parentItem.classList.remove('prd-Cards_CardWithVariants-active')
    }
  }

  handleProductWithVariantsClick (e) {
    const variantElement = e.target
    const parentItem = variantElement.closest('.js-ProductCards_Card')
    const variantId = variantElement.getAttribute('data-variant-id')
    const variantPrice = variantElement.getAttribute('data-variant-price')
    const variantCheckbox = parentItem.querySelector('.prd-Card_CheckboxInput')

    // Update the variant ID and price on the checkbox element
    variantCheckbox.setAttribute(
      'data-graphenehc-carousel-product-variant-id',
      variantId
    )
    variantCheckbox.setAttribute(
      'data-graphenehc-carousel-product-price',
      variantPrice
    )

    // Trigger updates immediately after selection
    this.handleProductCheckboxChange()
  }

  updateTotalPrice () {
    const checkedItems = document.querySelectorAll(
      '[data-graphenehc-multibuy-carousel-el="itemCheckbox"]:checked'
    )

    let total = 0

    checkedItems.forEach(item => {
      total += Number(
        item.getAttribute('data-graphenehc-carousel-product-price')
      )
    })

    document.querySelector(
      '[data-graphenehc-multibuy-carousel-el="totalPrice"]'
    ).innerHTML = window.theme.moneyFormat.replace(
      '{{amount}}',
      total.toFixed(2)
    )
  }

  updateTotalItems () {
    const checkedItems = document.querySelectorAll(
      '[data-graphenehc-multibuy-carousel-el="itemCheckbox"]:checked'
    )

    const totalItemsSelected = checkedItems.length

    document.querySelector(
      '[data-graphenehc-multibuy-carousel-el="totalItems"]'
    ).innerHTML = totalItemsSelected

    const submitButton = document
      .querySelector('[data-graphenehc-multibuy-carousel-external-el="submit"]')
      .querySelector('button')

    if (checkedItems.length >= 1) {
      submitButton.removeAttribute('disabled')
    } else {
      submitButton.setAttribute('disabled', 'true')
    }
  }

  updateItemsArray () {
    const checkedItems = document.querySelectorAll(
      '[data-graphenehc-multibuy-carousel-el="itemCheckbox"]:checked'
    )

    this.itemsArray = []

    checkedItems.forEach(item => {
      this.itemsArray.push({
        id: Number(
          item.getAttribute('data-graphenehc-carousel-product-variant-id')
        ),
        quantity: 1
      })
    })

    const storedVariantIdsElement = document.querySelector(
      '[data-graphenehc-multibuy-carousel-external-el="storedVariantIds"]'
    )
    storedVariantIdsElement.setAttribute(
      'data-graphene-carousel-selected-items',
      JSON.stringify(this.itemsArray)
    )
  }

  setupCarousel (carouselOptions) {
    const desktopCount = carouselOptions
      ? Number(
        carouselOptions.getAttribute(
          'data-graphenehc-carousel-desktop-slide-count'
        )
      )
      : 4

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 10
        },
        breakpoints: {
          '(min-width: 601px)': {
            slides: {
              perView: 2.5,
              spacing: 20
            }
          },
          '(min-width: 1201px)': {
            slides: {
              perView: desktopCount,
              spacing: 30
            }
          }
        }
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element
        })
      ]
    )
  }
}

if (!customElements.get('graphenehc-multibuy-carousel')) {
  customElements.define(
    'graphenehc-multibuy-carousel',
    GrapheneHCMultiBuyCarousel
  )
}
